import { createSlice } from '@reduxjs/toolkit';
import { IS_CASE_ENABLED, IS_CPR_ENABLED, IS_FAF_ENABLED } from '../../../constant/Constants';


const initialState = {
    PARTNER: {
        PROGRAM: 'PARTNER',
        PROGRAM_ID: '3',
    },
    CPR: {
        PROGRAM: "CPR",
        PROGRAM_ID: "1",
        isAvailable: IS_CPR_ENABLED,
        programName: "TotalAssist",
    },
    FAF: {
        PROGRAM: "FAF",
        PROGRAM_ID: "3",
        isAvailable: IS_FAF_ENABLED,
        programName: "FAF",
    },
    CASE: {
        PROGRAM: "CM",
        PROGRAM_ID: "0",
        isAvailable: IS_CASE_ENABLED,
        programName: "Case Management",
    },
}


const generalConfigSlice = createSlice({
    name: 'generalConfig',
    initialState,
    reducers: {
        setGeneralConfig: (state, action) => {

        },

    }
})


export default generalConfigSlice.reducer